import _                                from 'lodash'
import moment                           from 'moment'
import momentDurationFormatSetup        from 'moment-duration-format'
import React                            from 'react'
import { Checkbox, FormControl        } from 'react-bootstrap'
import { NumberPicker, DateTimePicker } from 'react-widgets'
import { Select                       } from 'alto-react-components/lib/components'

momentDurationFormatSetup(moment)

import Validator from './validator'

export inputFor = (spec, value, record, handler) ->
  property  = spec.property
  type      = spec.type      or 'text'
  disabled  = spec.disabled  or spec.disabledIf?(value, record)
  formatter = spec.formatter or defaultFormatterFor(spec)
  parser    = spec.parser    or defaultParserFor(spec)

  switch type
    when 'text', 'textarea', 'email', 'time-string', 'duration', 'time-as-duration'
      value  = formatter(value, record) if formatter
      onBlur = (event) -> handler(property, parser(event.target.value)) if parser
      props  =
        type:        type
        value:       value ? ''
        placeholder: spec.placeholder
        onBlur:      onBlur
        onChange:    (event) -> handler(property, event.target.value)
        onKeyPress:  (event) -> event.preventDefault() if event.key == 'Enter'

      if type == 'textarea'
        props.componentClass = 'textarea'
        delete props.onKeyPress

      <FormControl {...props} />
    when 'checkbox'
      <Checkbox defaultChecked={value}
                onChange={(event) -> handler(property, event.target.checked)} />
    when 'integer', 'smallint', 'bigint', 'float'
      [min, max] = boundsFor(spec)

      <NumberPicker value={value} min={min} max={max} step={spec.step ? 1}
                    onChange={(value) -> handler(property, value)} />
    when 'select'
      <Select options={spec.options} value={value} allowBlank={spec.allowBlank}
              onChange={(value) -> handler(property, value)} />
    when 'date'
      value = value ? spec.default
      value = value.toDate() if moment.isMoment(value)

      <DateTimePicker time={false} format="dd.MM.yyyy" value={value} disabled={disabled}
                      onChange={(value) -> handler(property, moment(value))} />
    when 'time'
      value = value ? spec.default
      value = value.toDate() if moment.isMoment(value)

      <DateTimePicker date={false} format="H:mm" value={value} disabled={disabled}
                      onChange={(value) -> handler(property, moment(value))} />
    when 'static'
      value  = formatter(value, record) if formatter

      <FormControl.Static>{value}</FormControl.Static>

export validateInput = (spec, value, record) ->
  formatter = spec.formatter or defaultFormatterFor(spec)
  value     = formatter(value, record) if formatter

  not spec.validator or Validator.for(spec)(value)

INT_MAX      = 2147483647
INT_MIN      = - (INT_MAX + 1)
BIGINT_MAX   = 9223372036854775807
BIGINT_MIN   = - (BIGINT_MAX + 1)
SMALLINT_MAX = 32767
SMALLINT_MIN = - (SMALLINT_MAX + 1)

boundsFor = (spec) ->
  [dbMin, dbMax] = switch spec.type
    when 'integer'  then [INT_MIN,      INT_MAX]
    when 'bigint'   then [BIGINT_MIN,   BIGINT_MAX]
    when 'smallint' then [SMALLINT_MIN, SMALLINT_MAX]

  max = spec.max ? dbMax
  min = spec.min ? if spec.allowNegative then dbMin else if spec.allowZero then 0 else 1

  [min, max]

export defaultFormatterFor = (spec) ->
  type = spec.type or 'text'

  switch type
    when 'time-string'
      (time)     -> if moment.isMoment(time)       then time.format('HH:mm')    else time
    when 'duration'
      (duration) -> if moment.isDuration(duration) then duration.format('H:mm') else duration
    when 'time-as-duration'
      (duration) -> if moment.isDuration(duration) then duration.format('H:mm') else duration

export defaultParserFor = (spec) ->
  type = spec.type or 'text'

  switch type
    when 'time-string'
      (string) ->
        time = moment(string, 'HH:mm')
        if time.isValid() then time else ''
    when 'duration'
      moment.duration
    when 'time-as-duration'
      (string) ->
        time = moment(string, 'HH:mm')
        if time.isValid() then moment.duration(string) else ''
